module.exports = __webpack_public_path__ + "img/learn.3a060ec5.png";